import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = { key: 5 }
const _hoisted_7 = { key: 6 }
const _hoisted_8 = { key: 7 }
const _hoisted_9 = { key: 8 }

import { reactive, ref, onMounted, computed } from 'vue';
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
  formOptions: {
    type: Object as PropType<Meatou.form>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  setup(__props, { expose }) {

const props = __props

const Options = ref({
  name: '表单'
})

onMounted(() => {

})



const formRef = ref()
const handleSubmit = () => {

  return formRef.value.validate()

}

expose({
  handleSubmit
})


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_m_select = _resolveComponent("m-select")!
  const _component_m_datetime = _resolveComponent("m-datetime")!
  const _component_m_upload_image = _resolveComponent("m-upload-image")!
  const _component_m_upload_file = _resolveComponent("m-upload-file")!
  const _component_select_corp = _resolveComponent("select-corp")!
  const _component_select_department = _resolveComponent("select-department")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createBlock(_component_van_form, {
    ref_key: "formRef",
    ref: formRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formOptions.fields, (field) => {
            return (_openBlock(), _createElementBlock("div", null, [
              (field.type === 'n-input')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_van_field, {
                      disabled: props.disabled,
                      modelValue: __props.formOptions.data[field.name],
                      "onUpdate:modelValue": ($event: any) => ((__props.formOptions.data[field.name]) = $event),
                      label: field.title,
                      placeholder: field.title,
                      rules: field.rules
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "label", "placeholder", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (field.type === 'n-select')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_m_select, {
                      disabled: props.disabled,
                      value: __props.formOptions.data[field.name],
                      "onUpdate:value": ($event: any) => ((__props.formOptions.data[field.name]) = $event),
                      options: field.options,
                      label: field.title,
                      rules: field.rules
                    }, null, 8, ["disabled", "value", "onUpdate:value", "options", "label", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (field.type === 'n-input-number')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_van_field, {
                      type: "number",
                      disabled: props.disabled,
                      modelValue: __props.formOptions.data[field.name],
                      "onUpdate:modelValue": ($event: any) => ((__props.formOptions.data[field.name]) = $event),
                      label: field.title,
                      placeholder: field.title,
                      rules: field.rules
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "label", "placeholder", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (field.type === 'el-date-picker')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_m_datetime, {
                      disabled: props.disabled,
                      value: __props.formOptions.data[field.name],
                      "onUpdate:value": ($event: any) => ((__props.formOptions.data[field.name]) = $event),
                      label: field.title,
                      placeholder: field.title,
                      rules: field.rules
                    }, null, 8, ["disabled", "value", "onUpdate:value", "label", "placeholder", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (field.type === 'upload-pic')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_m_upload_image, {
                      disabled: props.disabled,
                      value: __props.formOptions.data[field.name],
                      "onUpdate:value": ($event: any) => ((__props.formOptions.data[field.name]) = $event),
                      label: field.title,
                      name: field.name,
                      folder: field.folder,
                      placeholder: field.title,
                      rules: field.rules
                    }, null, 8, ["disabled", "value", "onUpdate:value", "label", "name", "folder", "placeholder", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (field.type === 'upload-file')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_m_upload_file, {
                      disabled: props.disabled,
                      value: __props.formOptions.data[field.name],
                      "onUpdate:value": ($event: any) => ((__props.formOptions.data[field.name]) = $event),
                      label: field.title,
                      name: field.name,
                      folder: field.folder,
                      placeholder: field.title,
                      rules: field.rules
                    }, null, 8, ["disabled", "value", "onUpdate:value", "label", "name", "folder", "placeholder", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (field.type === 'slot')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                : _createCommentVNode("", true),
              (field.type === 'select-corp')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_select_corp, {
                      disabled: props.disabled,
                      value: __props.formOptions.data[field.name],
                      "onUpdate:value": ($event: any) => ((__props.formOptions.data[field.name]) = $event),
                      label: field.title,
                      rules: field.rules
                    }, null, 8, ["disabled", "value", "onUpdate:value", "label", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (field.type === 'select-department')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_select_department, {
                      disabled: props.disabled,
                      value: __props.formOptions.data[field.name],
                      "onUpdate:value": ($event: any) => ((__props.formOptions.data[field.name]) = $event),
                      label: field.title,
                      rules: field.rules
                    }, null, 8, ["disabled", "value", "onUpdate:value", "label", "rules"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 256))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})